import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

export default function Datenschutz() {
  return (
    <div className="legal-root">
      <div className="legal-bg-grid" />
      <div className="legal-glow" />

      <header className="legal-header">
        <Link to="/" className="legal-logo">
          <img src="/logo.png" alt="CVFlow" className="legal-logo__dot" />
        </Link>
      </header>

      <main className="legal-main">
        <div className="legal-eyebrow">Rechtliche Informationen</div>
        <h1 className="legal-title">Datenschutzerklärung</h1>
        <div className="legal-divider" />

        <div className="legal-card">

          <section className="legal-section">
            <h2 className="legal-section__title">1. Verantwortlicher</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Verantwortlicher im Sinne der DSGVO für die Datenverarbeitung auf dieser Plattform ist die:
              </p>
              <p className="legal-prose" style={{ marginTop: 12 }}>
                Ahmet Furkan Yazgin &amp; Mehmet Yüksel GbR<br />
                Kaltenweide 182<br />
                25335 Elmshorn<br />
                E-Mail:{' '}
                <a href="mailto:info@cvflow.de" className="legal-inline-link">info@cvflow.de</a>
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">2. Erhebung und Verarbeitung personenbezogener Daten</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Wir erheben und verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer
                funktionsfähigen Software-as-a-Service-Lösung sowie unserer Inhalte und Leistungen erforderlich
                ist. Die Verarbeitung erfolgt primär auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO
                (Vertragserfüllung zur Bereitstellung von CVFlow) sowie Art. 6 Abs. 1 lit. f
                DSGVO (berechtigte Interessen an der Sicherheit und Stabilität des Systems).
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">3. Bereitstellung der Applikation und Hosting (GCP &amp; Firebase)</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Unsere Anwendung wird mithilfe der Infrastruktur von Google Cloud gehostet. Das Frontend nutzt
                Firebase Hosting, während das Backend auf der Google Cloud Platform (GCP) betrieben wird.
              </p>
              <ul className="legal-list" style={{ marginTop: 12 }}>
                <li>
                  <strong>Serverstandort:</strong> Die Verarbeitung und Speicherung der Daten erfolgt auf
                  Servern in der Region Frankfurt am Main, Deutschland (europe-west3).
                </li>
                <li>
                  <strong>Server-Logfiles:</strong> Der Hoster erhebt automatisch Daten, die dein Browser an
                  uns übermittelt (z.&nbsp;B. IP-Adresse, Browsertyp, Zeitpunkt der Anfrage). Dies dient der
                  technischen Fehleranalyse und der Abwehr von Angriffen.
                </li>
              </ul>
              <p className="legal-prose" style={{ marginTop: 12 }}>
                Mit der Google Cloud EMEA Ltd. wurde ein Vertrag zur Auftragsverarbeitung (AVV) gemäß
                Art. 28 DSGVO geschlossen.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">4. Firebase Authentication, Google OAuth &amp; LinkedIn</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Zur Nutzerauthentifizierung verwenden wir Firebase Authentication von Google sowie OAuth-Anmeldung
                über Google (Google LLC) und LinkedIn (LinkedIn Ireland Unlimited Company, Wilton Place, Dublin 2, Irland).
              </p>
              <ul className="legal-list" style={{ marginTop: 12 }}>
                <li>
                  Bei der E-Mail-Anmeldung werden E-Mail-Adresse und ein verschlüsseltes Passwort verarbeitet.
                </li>
                <li>
                  Nutzt du „Sign in with Google", erheben wir deinen Google-Anzeigenamen, deine E-Mail-Adresse
                  und dein Profilbild ausschließlich zur Identifikation innerhalb der App.
                </li>
                <li>
                  Nutzt du „Sign in with LinkedIn", erheben wir deinen LinkedIn-Anzeigenamen und deine
                  E-Mail-Adresse ausschließlich zur Identifikation innerhalb der App.
                </li>
              </ul>
              <p className="legal-prose" style={{ marginTop: 12 }}>
                Die Datenübertragung erfolgt auf Basis der EU-Standardvertragsklauseln. Weitere Informationen:{' '}
                <a
                  href="https://firebase.google.com/support/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="legal-inline-link"
                >
                  firebase.google.com/support/privacy
                </a>
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">5. Firestore Datenbank</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Sämtliche Nutzerdaten, Profilinformationen (beruflicher Werdegang, Zeugnisse) und Notizen
                werden in der Google Cloud Firestore gespeichert. Der Speicherort ist ebenfalls die Region
                Frankfurt am Main. Die Daten werden ausschließlich zur Bereitstellung der Softwarefunktionen
                verwendet. Jeder Nutzer hat systemseitig ausschließlich Zugriff auf seine eigenen Daten und
                kann diese über sein Dashboard jederzeit unwiderruflich löschen.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">6. KI-gestützte Textgenerierung (Claude API)</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Zur Analyse von Stellenanzeigen und Generierung von Bewerbungstexten nutzen wir die Claude API
                von Anthropic, PBC (548 Market St, PMB 90375, San Francisco, CA 94104, USA).
              </p>
              <ul className="legal-list" style={{ marginTop: 12 }}>
                <li>
                  <strong>Datenübermittlung:</strong> An die API werden ausschließlich berufliche
                  Profilinhalte (z.&nbsp;B. Berufserfahrung, Ausbildung, Kenntnisse) sowie die Inhalte der
                  Stellenanzeige übermittelt. Persönliche Kontaktfelder wie Name, Adresse und Telefonnummer
                  sind systemseitig von der KI-Anfrage ausgeschlossen und werden nicht an Anthropic gesendet.
                </li>
                <li>
                  <strong>Kein Modell-Training:</strong> Anthropic nutzt die über die API übermittelten Daten
                  ausdrücklich nicht zum Training seiner KI-Modelle. Deine Daten werden lediglich für den
                  Moment der Dokumentengenerierung verarbeitet.
                </li>
              </ul>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">7. Web-Scraping / Import-Funktion</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Nutzt du die Funktion zum Importieren von Stellenanzeigen via URL, ruft unser in Frankfurt
                gehostetes Backend die entsprechende Webseite ab. Dabei wird die URL verarbeitet, um den Text
                der Stellenanzeige für die anschließende KI-Analyse zu extrahieren.
              </p>
              <p className="legal-prose" style={{ marginTop: 12 }}>
                Als technischen Fallback für schwer erreichbare Webseiten setzen wir den Dienst{' '}
                <strong>ScrapingBee</strong> (Unterauftragsverarbeiter: ScrapingBee SAS, Frankreich) ein.
                Dabei wird ausschließlich die eingegebene URL an ScrapingBee übermittelt, um den
                Stellenanzeigentext abzurufen. Mit ScrapingBee besteht ein Vertrag zur Auftragsverarbeitung
                gemäß Art.&nbsp;28 DSGVO.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">8. Zahlungsabwicklung über Stripe</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Für kostenpflichtige Abonnements und Zahlungen verwenden wir den Zahlungsdienstleister
                <strong> Stripe</strong> (Stripe Payments Europe, Ltd., 1 Grand Canal Street Lower,
                Grand Canal Dock, Dublin, Irland). Wenn du einen kostenpflichtigen Plan auswählst,
                wirst du zur sicheren Zahlungsseite von Stripe weitergeleitet.
              </p>
              <p className="legal-prose" style={{ marginTop: 12 }}>
                Stripe verarbeitet dabei die für die Zahlung erforderlichen Daten, z.&nbsp;B. Zahlungsbetrag,
                gewählten Plan, Rechnungs- und Zahlungsdaten, E-Mail-Adresse sowie technische Daten zur
                Betrugsprävention und Zahlungsabwicklung. Wir speichern in CVFlow keine vollständigen
                Kreditkarten- oder Zahlungsdaten.
              </p>
              <p className="legal-prose" style={{ marginTop: 12 }}>
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie Art. 6 Abs. 1
                lit. f DSGVO (berechtigtes Interesse an sicherer Zahlungsabwicklung und Missbrauchsschutz).
                Weitere Informationen findest du in der Datenschutzerklärung von Stripe:{' '}
                <a
                  href="https://stripe.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="legal-inline-link"
                >
                  stripe.com/privacy
                </a>
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">9. Cookies, lokaler Speicher und Analyse-Tools</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Wir verwenden den localStorage des Browsers zur Speicherung von lokalen Nutzereinstellungen
                und Sitzungsdaten (z.&nbsp;B. Onboarding-Status, Cookie-Einwilligung). Firebase Authentication
                nutzt zudem die IndexedDB zur Speicherung von Authentifizierungstoken.
              </p>
              <p className="legal-prose" style={{ marginTop: 12 }}>
                <strong>Analyse- und Marketing-Cookies (nur mit deiner Einwilligung):</strong>
              </p>
              <p className="legal-prose" style={{ marginTop: 8 }}>
                Wenn du der Verwendung von Analyse- und Marketing-Cookies zustimmst, setzen wir folgende
                Dienste ein:
              </p>
              <ul className="legal-list">
                <li>
                  <strong>Google Analytics 4 / Firebase Analytics</strong> (Anbieter: Google Ireland Ltd.,
                  Gordon House, Barrow Street, Dublin 4, Irland). Wir nutzen Firebase Analytics, das auf
                  Google Analytics 4 basiert, zur Analyse des Nutzungsverhaltens auf unserer Website und in
                  der App. Dabei können Daten in die USA übermittelt werden. Google ist dem EU-US Data Privacy
                  Framework beigetreten. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
                </li>
                <li style={{ marginTop: 8 }}>
                  <strong>PostHog</strong> (Anbieter: PostHog Inc.; EU-Cloud-Hosting über
                  eu.i.posthog.com). Wir nutzen PostHog zur produktbezogenen Nutzungsanalyse, um zu
                  verstehen, an welchen Stellen Nutzer den Registrierungs-, Onboarding-, Generierungs-
                  und Kaufprozess erfolgreich durchlaufen oder abbrechen. Erfasst werden pseudonyme
                  Ereignisse wie Seitenaufrufe, CTA-Klicks, Registrierungsstatus, Profilerstellung,
                  Job-Generierung, Checkout-Start und Kaufabschluss sowie begrenzte Eigenschaften wie
                  CTA-Position, Registrierungsmethode, Quelle der Job-Erstellung oder gewählter Plan.
                  Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
                </li>
                <li style={{ marginTop: 8 }}>
                  <strong>TikTok Pixel</strong> (Anbieter: TikTok Technology Limited, 10 Earlsfort Terrace,
                  Dublin 2, D02 T380, Irland). Das TikTok Pixel ermöglicht es uns, Conversions aus
                  TikTok-Werbeanzeigen zu messen. Dabei können Daten in die USA und nach Singapur übermittelt
                  werden. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).
                </li>
              </ul>
              <p className="legal-prose" style={{ marginTop: 12 }}>
                Bei der Analyse erfassen wir keine Inhalte aus Lebensläufen, Stellenanzeigen, Anschreiben,
                Profil-Freitexten, Notizen, Namen, Telefonnummern oder sonstigen Bewerbungsunterlagen.
                Diese Inhalte werden nicht an Analyse- oder Marketingdienste übermittelt.
              </p>
              <p className="legal-prose" style={{ marginTop: 12 }}>
                In der App kannst du deine Einwilligung jederzeit unter Einstellungen → Datenschutz
                widerrufen. Auf der Website kannst du dafür auf{' '}
                <button
                  onClick={() => {
                    const { resetConsent } = require('./tracking/consent');
                    resetConsent();
                    window.location.reload();
                  }}
                  style={{
                    background: 'none', border: 'none', padding: 0,
                    color: 'var(--cv-teal, #004D40)', textDecoration: 'underline',
                    cursor: 'pointer', font: 'inherit',
                  }}
                >
                  Einwilligung widerrufen
                </button>{' '}
                klickst. Danach erscheint beim nächsten Seitenaufruf erneut der Cookie-Banner.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">10. Fehleranalyse mit Sentry</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Zur technischen Fehleranalyse und Stabilitätsüberwachung setzen wir
                <strong> Sentry</strong> (Functional Software, Inc., 45 Fremont Street, 8th Floor,
                San Francisco, CA 94105, USA) ein. Sentry hilft uns, Programmfehler, Abstürze und
                Performance-Probleme zu erkennen und zu beheben.
              </p>
              <p className="legal-prose" style={{ marginTop: 12 }}>
                Dabei können technische Daten wie Fehlermeldungen, Stacktraces, Browser- und Gerätedaten,
                Zeitpunkt des Fehlers, betroffene URL und eine pseudonyme Nutzerkennung verarbeitet werden.
                Inhalte aus Lebensläufen, Stellenanzeigen, Anschreiben oder Freitextfeldern werden nicht
                gezielt an Sentry übermittelt.
              </p>
              <p className="legal-prose" style={{ marginTop: 12 }}>
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Sicherheit,
                Stabilität und Fehlerbehebung). Weitere Informationen:{' '}
                <a
                  href="https://sentry.io/privacy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="legal-inline-link"
                >
                  sentry.io/privacy
                </a>
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">11. Deine Rechte</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Du hast jederzeit das Recht auf:
              </p>
              <ul className="legal-list">
                <li>Auskunft über deine gespeicherten Daten (Art. 15 DSGVO)</li>
                <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
                <li>Löschung deiner Daten (Art. 17 DSGVO)</li>
                <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
              </ul>
              <p className="legal-prose" style={{ marginTop: 12 }}>
                Zur Ausübung deiner Rechte kontaktiere uns unter:{' '}
                <a href="mailto:info@cvflow.de" className="legal-inline-link">info@cvflow.de</a>
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">12. Beschwerderecht</h2>
            <div className="legal-block">
              <p className="legal-prose">
                Zuständige Aufsichtsbehörde: Unabhängiges Landeszentrum für Datenschutz
                Schleswig-Holstein (ULD), Holstenstraße 98, 24103 Kiel.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="legal-section__title">13. Aktualität dieser Erklärung</h2>
            <div className="legal-block">
              <p className="legal-prose">Stand: Juni 2026.</p>
            </div>
          </section>

        </div>

        <div className="legal-footer-nav">
          <Link to="/agb" className="legal-footer-link">AGB →</Link>
          <Link to="/impressum" className="legal-footer-link">Impressum →</Link>
        </div>
      </main>

      <footer className="legal-footer">
        <div className="legal-footer__inner">
          <div className="legal-footer__brand">
            <img src="/logo.png" alt="CVFlow" className="legal-footer__brand-dot" />
          </div>
          <nav className="legal-footer__links">
            <Link to="/impressum">Impressum</Link>
            <Link to="/agb">AGB</Link>
            <Link to="/datenschutz">Datenschutz</Link>
          </nav>
          <div className="legal-footer__status">
            <span className="legal-footer__status-dot" aria-hidden="true" />
            System Online · Made in Germany
          </div>
        </div>
      </footer>
    </div>
  );
}
